export type KrpanoViewerType = 'full' | 'preview' | 'viewer' | string

export class KrpanoEngine {
  private elementId: string

  constructor(type: KrpanoViewerType = 'full') {
    if (type === 'full' || type === 'preview' || type === 'viewer') {
      this.elementId = `embedpano-${type}`
    } else {
      this.elementId = type
    }
  }

  // Raw Krpano Interface
  get instance(): any {
    return document.getElementById(this.elementId)
  }

  // Common View Properties
  get hlookat(): number | null {
    const val = this.instance?.get('view.hlookat')
    return val !== undefined && val !== null ? Number(val) : null
  }

  get vlookat(): number | null {
    const val = this.instance?.get('view.vlookat')
    return val !== undefined && val !== null ? Number(val) : null
  }

  get fov(): number | null {
    const val = this.instance?.get('view.fov')
    return val !== undefined && val !== null ? Number(val) : null
  }

  // Scene Properties
  get currentScene(): string | null {
    return this.instance?.get('xml.scene') ?? null
  }

  get renderedImageId(): number | null {
    const scene = this.currentScene
    if (typeof scene === 'string' && scene.startsWith('scene_')) {
      const id = Number(scene.replace('scene_', ''))
      return Number.isNaN(id) ? null : id
    }
    return null
  }

  // Transition / Loading state
  get isLoadComplete(): boolean {
    const val = this.instance?.get('loadcomplete')
    return val !== false && val !== 'false'
  }

  // Active scene point lookup
  getActivePoint<
    T extends {
      image360?: { id?: number } | null
      subImages?: { id?: number }[]
    }
  >(points: T[]): T | undefined {
    const imageId = this.renderedImageId
    if (!imageId || !points?.length) return undefined

    return points.find(
      (p) =>
        p.image360?.id === imageId || p.subImages?.some((s) => s.id === imageId)
    )
  }

  // Raw Interop
  call(action: string): void {
    this.instance?.call(action)
  }

  get(variable: string): any {
    return this.instance?.get(variable)
  }

  set(variable: string, value: any): void {
    this.instance?.set(variable, value)
  }
}
